module.exports = __webpack_public_path__ + "img/00020c3.png";